import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeService, setActiveService] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      title: 'Slab Jacking & Leveling',
      description: 'Special concrete mix that lifts and stabilizes sunken concrete driveways, patios, sidewalks, and garage floors. Fast, clean and a permanent solution.',
      icon: 'ri-home-4-line',
      image: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e57b3fdeb102c6d6279629406f84d15d.jpeg'
    },
    {
      title: 'Basement Waterproofing',
      description: 'Complete interior and exterior drainage systems, sump pump installation, and vapor barriers to keep your basement dry and protected year-round.',
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/b4132c3cd6c3e3a8b14e4691c1fcb6c7.jpg'
    },
    {
      title: 'Foundation Crack Repair',
      description: 'Expert epoxy and polyurethane injection for both structural and non-structural cracks. Permanent repairs that restore your foundation\'s integrity.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20professional%20foundation%20crack%20repair%20injection%20process%20with%20epoxy%20application%20equipment%20on%20concrete%20wall%20showing%20detailed%20repair%20work%20with%20simple%20clean%20background&width=800&height=1000&seq=crack1&orientation=portrait'
    }
  ];

  const projects = [
    {
      title: 'Driveway Leveling',
      location: 'Windsor, ON',
      date: 'March 2024',
      before: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/58fe4897f1a66f39caa6b9e22fd84b4a.jpeg',
      after: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/615ff43196517571cf2612c8cb363603.jpeg'
    },
    {
      title: 'Sidewalk Leveling',
      location: 'Essex, ON',
      date: 'February 2024',
      before: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/0448121315267ba0e5140635b5e84404.jpeg',
      after: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/28d781d085315f3c64108554d5f5778d.jpeg'
    },
    {
      title: 'Driveway Leveling',
      location: 'Belle River, ON',
      date: 'January 2024',
      before: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e6f26ae702c0a16523ef6d0271c98e57.jpeg',
      after: 'https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/bfe5b6a1166695d4d2ca472149822a9f.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || mobileMenuOpen ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-4 md:px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img src="https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e8a463460a8c4c4f05ea72f0c7b7543f.png" alt="LevelPro Solutions Inc" className="h-10 md:h-12 w-auto" />
            </div>
            {/* Desktop Nav */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#home" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#7FD858]' : 'text-white hover:text-[#7FD858]'}`}>Home</a>
              <a href="#about" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#7FD858]' : 'text-white hover:text-[#7FD858]'}`}>About Us</a>
              <a href="#services" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#7FD858]' : 'text-white hover:text-[#7FD858]'}`}>Services</a>
              <a href="#projects" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#7FD858]' : 'text-white hover:text-[#7FD858]'}`}>Projects</a>
              <a href="#contact" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#7FD858]' : 'text-white hover:text-[#7FD858]'}`}>Contact</a>
            </div>
            <div className="flex items-center gap-3">
              <a href="#contact" className="bg-[#7FD858] text-white px-4 md:px-6 py-2 md:py-2.5 rounded-full text-sm font-semibold hover:bg-[#6BC847] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                Free Quote
              </a>
              {/* Hamburger */}
              <button
                className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle menu"
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled || mobileMenuOpen ? 'text-gray-800' : 'text-white'}`}></i>
              </button>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col space-y-4">
            {['home', 'about', 'services', 'projects', 'contact'].map((item) => (
              <a
                key={item}
                href={`#${item}`}
                className="text-gray-700 font-medium text-base capitalize py-1 hover:text-[#7FD858] transition-colors cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item === 'home' ? 'Home' : item === 'about' ? 'About Us' : item.charAt(0).toUpperCase() + item.slice(1)}
              </a>
            ))}
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 flex">
          <div className="w-1/2 relative">
            <img
              src="https://readdy.ai/api/search-image?query=sunken%20cracked%20concrete%20sidewalk%20with%20trip%20hazards%20and%20uneven%20sections%20along%20residential%20property%20simple%20background%20before%20repair&width=960&height=1080&seq=proj6before&orientation=portrait"
              alt="Before concrete repair"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1A3A2E]/80 via-[#1A3A2E]/60 to-transparent"></div>
          </div>
          <div className="w-1/2 relative">
            <img
              src="https://readdy.ai/api/search-image?query=perfectly%20level%20smooth%20concrete%20sidewalk%20restored%20and%20safe%20along%20residential%20property%20with%20clean%20appearance%20simple%20background%20after%20repair&width=960&height=1080&seq=proj6after&orientation=portrait"
              alt="After concrete repair"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-[#1A3A2E]/80 via-[#1A3A2E]/60 to-transparent"></div>
          </div>
          <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-1 bg-white/40 z-10"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-[#7FD858] rounded-full flex items-center justify-center shadow-xl z-20">
            <i className="ri-arrow-left-right-line text-white text-lg md:text-xl"></i>
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 py-28 md:py-32">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
              LEVEL YOUR CONCRETE<br />
              PROTECT YOUR BASEMENT<br />
              TRUST THE PROS
            </h1>
            <p className="text-base md:text-xl text-gray-200 mb-8 md:mb-10 leading-relaxed max-w-xl">
              Professional Slab Jacking and waterproofing services across Windsor Essex county area and over 10 years of experience.
            </p>
            <div className="flex flex-wrap gap-3 md:gap-4">
              <a href="#contact" className="bg-[#7FD858] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#6BC847] transition-all shadow-lg whitespace-nowrap cursor-pointer">
                Get Free Estimate
              </a>
              <a href="#projects" className="border-2 border-white text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-white hover:text-[#2D5F3F] transition-all whitespace-nowrap cursor-pointer">
                View Our Work
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
            <div>
              <div className="inline-block bg-gray-100 text-gray-600 px-4 py-2 rounded-full text-sm font-medium mb-4 md:mb-6">
                ABOUT LEVELPRO
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-[#2D5F3F] mb-4 md:mb-6 leading-tight">
                Foundation Experts<br />You Can Trust
              </h2>
              <p className="text-gray-600 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
                LevelPro Solutions Inc. has over a decade of experience serving the Greater Windsor–Essex County area with trusted concrete lifting, basement waterproofing, and foundation repair services. Our team uses advanced technology and proven methods to provide durable and dependable solutions.
              </p>
              <p className="text-gray-600 mb-6 md:mb-8 leading-relaxed text-sm md:text-base">
                We're committed to transparency, quality workmanship, and customer satisfaction.
              </p>
              <a href="#contact" className="text-[#7FD858] font-semibold inline-flex items-center hover:text-[#6BC847] transition-colors cursor-pointer">
                Our Story
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>

            <div className="bg-[#2D5F3F] rounded-3xl p-8 md:p-10 shadow-2xl">
              <div className="flex justify-between items-start mb-6 md:mb-8">
                <p className="text-[#7FD858] text-sm font-medium">COMPANY MILESTONE</p>
                <i className="ri-more-fill text-[#7FD858] text-xl"></i>
              </div>
              <blockquote className="text-white text-xl md:text-2xl font-medium leading-relaxed mb-8 md:mb-12">
                "Over 5,000 foundations repaired and protected.
              </blockquote>
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#7FD858] rounded-full flex flex-col items-center justify-center">
                  <span className="text-white text-2xl md:text-3xl font-bold">10+</span>
                </div>
                <div>
                  <p className="text-white text-sm">Years</p>
                  <p className="text-white text-sm">Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-16">
            <div className="inline-block bg-[#7FD858] text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
              OUR EXPERTISE
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#2D5F3F] mb-4">Complete Foundation Solutions</h2>
            <p className="text-gray-600 text-base md:text-lg">From lifting sunken concrete to keeping basements dry</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl"
                style={{ height: '420px' }}
                onMouseEnter={() => setActiveService(index)}
                onClick={() => setActiveService(index)}
              >
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A3A2E]/95 via-[#1A3A2E]/60 to-transparent"></div>
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-white text-2xl md:text-3xl`}></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="text-white text-xl md:text-2xl font-bold mb-3">{service.title}</h3>
                  <p className={`text-gray-200 text-sm leading-relaxed mb-4 transition-all duration-500 ${activeService === index ? 'opacity-100 max-h-32' : 'opacity-0 max-h-0 overflow-hidden'}`}>
                    {service.description}
                  </p>
                  <a href="#contact" className="text-[#7FD858] font-semibold inline-flex items-center hover:text-[#6BC847] transition-colors cursor-pointer">
                    Learn More
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
                {activeService === index && (
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#7FD858]"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 md:py-24 bg-[#F0F5F0]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-10 md:mb-16 gap-4">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <span className="text-[#7FD858] text-2xl">•</span>
                <span className="text-[#2D5F3F] text-sm font-bold uppercase tracking-wider">HOW WE WORK</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-[#2D5F3F]">Simple Process, Lasting Results</h2>
            </div>
            <p className="text-gray-600 max-w-md text-sm md:text-base hidden md:block">
              We believe in transparency and clear communication throughout every step of your project.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative max-w-4xl mx-auto">
            <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 border-t-2 border-[#7FD858]" style={{ width: 'calc(100% - 120px)', marginLeft: '60px' }}></div>
            {[
              { number: '1', title: 'Free Inspection', description: 'We assess your property and identify the root cause of the problem with a thorough inspection.', icon: 'ri-search-line' },
              { number: '2', title: 'Free Detailed Quote', description: 'Receive a transparent, itemized quote with no hidden fees or surprises.', icon: 'ri-file-list-3-line' },
              { number: '3', title: 'Expert Execution', description: 'Our certified technicians complete the work efficiently using proven methods and quality materials.', icon: 'ri-tools-line' }
            ].map((step, index) => (
              <div key={index} className="relative bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-[#7FD858] rounded-full flex items-center justify-center text-white text-xl md:text-2xl font-bold mb-4 md:mb-6 mx-auto relative z-10">
                  {step.number}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-[#2D5F3F] mb-3 text-center">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed text-center mb-4 md:mb-6">{step.description}</p>
                <div className="flex justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 border-2 border-[#7FD858] rounded-full flex items-center justify-center">
                    <i className={`${step.icon} text-[#7FD858] text-lg md:text-xl`}></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10 md:mt-12">
            <a href="#contact" className="bg-[#7FD858] text-white px-8 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#6BC847] transition-all shadow-lg hover:shadow-xl inline-flex items-center whitespace-nowrap cursor-pointer">
              Start Your Project Today
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20construction%20crew%20team%20working%20on%20concrete%20leveling%20project%20with%20modern%20equipment%20and%20tools%20on%20residential%20property%20in%20bright%20daylight%20showing%20skilled%20workers%20in%20action%20with%20simple%20clean%20background&width=1920&height=600&seq=cta1&orientation=landscape"
            alt="Professional Team"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#2D5F3F]/85"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 uppercase tracking-tight">
            READY TO LEVEL UP YOUR PROPERTY?
          </h2>
          <p className="text-base md:text-xl text-white mb-8 md:mb-10 leading-relaxed">
            Get your free, no-obligation estimate today. Most projects completed in one day with minimal disruption.
          </p>
          <a href="tel:+15199038995" className="inline-flex items-center bg-[#7FD858] text-white px-6 md:px-8 py-4 md:py-5 rounded-full text-base md:text-lg font-bold hover:bg-[#6BC847] transition-all shadow-2xl animate-pulse cursor-pointer whitespace-nowrap">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
              <i className="ri-phone-fill text-[#7FD858] text-lg md:text-xl"></i>
            </div>
            CALL NOW: (519) 903-8995
            <i className="ri-arrow-right-up-line ml-2 md:ml-3 text-xl md:text-2xl"></i>
          </a>
          <p className="text-white text-sm mt-4">Or request a callback online</p>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-16">
            <div className="inline-block bg-[#7FD858] text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
              OUR WORK
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#2D5F3F]">Proven Results</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {projects.map((project, index) => (
              <div key={index} className="group relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer" style={{ height: '400px' }}>
                <div className="absolute inset-0 flex">
                  <div className="w-1/2 relative overflow-hidden">
                    <img src={project.before} alt="Before" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute top-3 left-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                      BEFORE
                    </div>
                  </div>
                  <div className="w-1/2 relative overflow-hidden">
                    <img src={project.after} alt="After" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute top-3 right-3 bg-[#7FD858] text-white px-2 py-1 rounded-full text-xs font-bold">
                      AFTER
                    </div>
                  </div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-[#7FD858] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                    <i className="ri-arrow-left-right-line text-white text-lg md:text-xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-[#2D5F3F]/95 backdrop-blur-sm p-4 md:p-6">
                  <h3 className="text-white text-base md:text-lg font-bold mb-2">{project.title}</h3>
                  <div className="flex justify-between items-center">
                    <p className="text-gray-300 text-xs">{project.location}</p>
                    <a href="#contact" className="text-[#7FD858] font-semibold text-sm hover:text-[#6BC847] transition-colors cursor-pointer whitespace-nowrap">
                      View Details
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16">
            <div>
              <div className="inline-block bg-[#7FD858] text-white px-4 py-2 rounded-full text-sm font-medium mb-4 md:mb-6">
                GET IN TOUCH
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-[#2D5F3F] mb-4 md:mb-6">Let's Fix Your Foundation</h2>
              <p className="text-gray-600 mb-8 md:mb-10 leading-relaxed text-sm md:text-base">
                Ready to get started? Fill out the form and we'll contact you within 24 hours to schedule your free inspection.
              </p>

              <div className="space-y-5 md:space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#7FD858] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#2D5F3F] mb-1 text-sm md:text-base">Phone</p>
                    <a href="tel:+15199038995" className="text-gray-600 hover:text-[#7FD858] transition-colors cursor-pointer text-sm md:text-base">(519) 903-8995</a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#7FD858] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-white text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#2D5F3F] mb-1 text-sm md:text-base">Email</p>
                    <a href="mailto:Levelprosolution@gmail.com" className="text-gray-600 hover:text-[#7FD858] transition-colors cursor-pointer text-sm break-all">Levelprosolution@gmail.com</a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#7FD858] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-white text-lg md:text-xl"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-bold text-[#2D5F3F] mb-2 text-sm md:text-base">Business Hours</p>
                    <div className="space-y-1">
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-gray-600 text-sm">Monday – Friday</span>
                        <span className="text-[#2D5F3F] font-semibold text-sm whitespace-nowrap">8:00 AM – 5:00 PM</span>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-gray-600 text-sm">Saturday</span>
                        <span className="text-[#2D5F3F] font-semibold text-sm whitespace-nowrap">8:00 AM – 2:00 PM</span>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-gray-600 text-sm">Sunday</span>
                        <span className="text-gray-400 text-sm">Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-3xl p-6 md:p-8 shadow-xl">
              <form
                id="contact-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d6mi4bqqoe30lj0v8c90"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.target as HTMLFormElement;
                  const formData = new FormData(form);
                  const name = formData.get('name') as string;
                  const email = formData.get('email') as string;
                  const phone = formData.get('phone') as string;
                  const service = formData.get('service') as string;
                  const message = formData.get('message') as string;
                  if (!name || !email || !phone || !service || !message) return;
                  if (message.length > 500) return;
                  const urlEncodedData = new URLSearchParams();
                  urlEncodedData.append('name', name);
                  urlEncodedData.append('email', email);
                  urlEncodedData.append('phone', phone);
                  urlEncodedData.append('service', service);
                  urlEncodedData.append('message', message);
                  fetch('https://readdy.ai/api/form/d6mi4bqqoe30lj0v8c90', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: urlEncodedData.toString()
                  }).then(response => {
                    if (response.ok) { form.reset(); }
                  });
                }}
              >
                <div className="mb-4 md:mb-6">
                  <label htmlFor="name" className="block text-sm font-semibold text-[#2D5F3F] mb-2">Full Name *</label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7FD858] text-sm" placeholder="John Smith" />
                </div>
                <div className="mb-4 md:mb-6">
                  <label htmlFor="email" className="block text-sm font-semibold text-[#2D5F3F] mb-2">Email Address *</label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7FD858] text-sm" placeholder="john@example.com" />
                </div>
                <div className="mb-4 md:mb-6">
                  <label htmlFor="phone" className="block text-sm font-semibold text-[#2D5F3F] mb-2">Phone Number *</label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7FD858] text-sm" placeholder="(416) 555-0123" />
                </div>
                <div className="mb-4 md:mb-6">
                  <label htmlFor="service" className="block text-sm font-semibold text-[#2D5F3F] mb-2">Service Needed *</label>
                  <select id="service" name="service" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7FD858] text-sm cursor-pointer">
                    <option value="">Select a service</option>
                    <option value="Slab Jacking">Slab Jacking &amp; Leveling</option>
                    <option value="Basement Waterproofing">Basement Waterproofing</option>
                    <option value="Crack Repair">Foundation Crack Repair</option>
                    <option value="Inspection">Free Inspection</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="mb-4 md:mb-6">
                  <label htmlFor="message" className="block text-sm font-semibold text-[#2D5F3F] mb-2">Message * (Max 500 characters)</label>
                  <textarea id="message" name="message" required maxLength={500} rows={4} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7FD858] text-sm resize-none" placeholder="Tell us about your project..."></textarea>
                </div>
                <button type="submit" className="w-full bg-[#7FD858] text-white py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#6BC847] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A3A2E] text-white pt-14 md:pt-20 pb-10 md:pb-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
            <div>
              <img src="https://static.readdy.ai/image/8cf2e6dda060150729bcd3e64b1f6e1d/e8a463460a8c4c4f05ea72f0c7b7543f.png" alt="LevelPro Solutions Inc" className="h-10 md:h-12 w-auto mb-4 md:mb-6 brightness-0 invert" />
              <p className="text-gray-400 text-sm leading-relaxed mb-4 md:mb-6">
                Professional concrete leveling, basement waterproofing, and foundation repair services across the Windsor Essex County Area.
              </p>
              <div className="flex space-x-3">
                <a href="#" className="w-9 h-9 md:w-10 md:h-10 border-2 border-[#7FD858] rounded-full flex items-center justify-center hover:bg-[#7FD858] transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-[#7FD858] hover:text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 md:w-10 md:h-10 border-2 border-[#7FD858] rounded-full flex items-center justify-center hover:bg-[#7FD858] transition-all cursor-pointer">
                  <i className="ri-instagram-line text-[#7FD858] hover:text-white text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 md:w-10 md:h-10 border-2 border-[#7FD858] rounded-full flex items-center justify-center hover:bg-[#7FD858] transition-all cursor-pointer">
                  <i className="ri-linkedin-fill text-[#7FD858] hover:text-white text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-gray-400 text-sm font-bold uppercase tracking-wider mb-4 md:mb-6">SERVICES</h4>
              <ul className="space-y-3">
                <li><a href="#services" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer">Concrete Leveling</a></li>
                <li><a href="#services" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer">Basement Waterproofing</a></li>
                <li><a href="#services" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer">Crack Repair</a></li>
                <li><a href="#contact" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer">Foundation Inspection</a></li>
              </ul>
              <h4 className="text-gray-400 text-sm font-bold uppercase tracking-wider mt-8 mb-4">SERVICE AREAS</h4>
              <ul className="space-y-2">
                {['Windsor', 'Essex', 'Belle River', 'Amherstburg', 'Kingsville', 'Leamington', 'Tilbury'].map((area) => (
                  <li key={area} className="flex items-center space-x-2">
                    <i className="ri-map-pin-2-line text-[#7FD858] text-xs"></i>
                    <span className="text-white text-sm">{area}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-gray-400 text-sm font-bold uppercase tracking-wider mb-4 md:mb-6">GET IN TOUCH</h4>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <i className="ri-phone-line text-[#7FD858] text-lg mt-0.5"></i>
                  <a href="tel:+15199038995" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer">(519) 903-8995</a>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-mail-line text-[#7FD858] text-lg mt-0.5 flex-shrink-0"></i>
                  <a href="mailto:Levelprosolution@gmail.com" className="text-white hover:text-[#7FD858] transition-colors text-sm cursor-pointer break-all">Levelprosolution@gmail.com</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-gray-400 text-sm font-bold uppercase tracking-wider mb-4 md:mb-6">STAY INFORMED</h4>
              <p className="text-gray-400 text-sm mb-4">Tips, offers, and foundation care advice</p>
              <form className="relative" onSubmit={(e) => { e.preventDefault(); (e.target as HTMLFormElement).reset(); }}>
                <input
                  type="email"
                  placeholder="Your email address"
                  className="w-full bg-transparent border-b-2 border-gray-600 text-white placeholder-gray-500 py-3 pr-10 focus:outline-none focus:border-[#7FD858] text-sm"
                  required
                />
                <button type="submit" className="absolute right-0 top-1/2 transform -translate-y-1/2 text-[#7FD858] hover:text-[#6BC847] transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="pt-8 md:pt-12 border-t border-gray-700 text-center">
            <p className="text-gray-400 text-xs">© 2025 LevelPro Solutions Inc. | Privacy Policy</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
